






















import Vue from 'vue';
import AppHelper from '@/helpers/AppHelper';
import { IMenuItem } from '@/common/interfaces/header.interface';
import ArrowIcon from '../../icons/ArrowIcon.vue';
import CustomerHelper from '../../../helpers/CustomerHelper';

export default Vue.extend({
  name: `MobileMenuEntry`,
  components: {
    ArrowIcon,
  },
  computed: {
    hideMobile(): boolean {
      return this.itemData.delegate === `hideOnMobile`;
    },
  },
  props: {
    arrowClass: {
      default: ``,
      type: String,
    },
    arrowColor: {
      default: `#ffffff`,
      type: String,
    },
    itemData: {
      required: true,
      type: Object as () => IMenuItem,
    },
    withArrow: {
      default: false,
      type: Boolean,
    },
  },
  methods: {
    async clickedEntry(): Promise<void> {
      if(this.itemData.children.length > 0) {
        this.$emit(`click`);
      } else if(this.itemData.link) {
        window.location.href = AppHelper.partnerShopLink(String(this.itemData.link));
      } else if(this.itemData.delegate !== null) {
        const delegate = String(this.itemData.delegate);
        if(delegate === `logout`) {
          await CustomerHelper.logout();
          window.location.href = `/`;
        }
        if(delegate === `subscribeNewsletter`) {
          const newsletterSection = document.getElementById(`newsletter`);
          if(window.location.pathname !== `/`) {
            window.location.href = `/#newsletter`;
          } else {
            newsletterSection?.scrollIntoView();
          }
        }
      }
    },
  },
});
